import * as Yup from "yup";
import {yupRequiredArray, yupRequiredString} from "../yup/Validators";

export const CreateRuleSchema = Yup.object().shape({
  profiles: yupRequiredArray(1),
  description: yupRequiredString,
})
